import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const FORNECEDORES = { ta: 'Tá Telecom', tip: 'Tip Brasil' };

export const FornecedorBadge = ({ fornecedor, testId }) => {
  const tip = fornecedor === 'tip';
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${tip ? 'bg-violet-950/50 text-violet-300 border-violet-700/60' : 'bg-sky-950/50 text-sky-300 border-sky-700/60'}`}
      data-testid={testId}
    >
      {tip ? 'Tip' : 'Tá'}
    </span>
  );
};

export const FornecedorSelect = ({ value, onChange, testId, label = 'Operadora' }) => (
  <div className="space-y-2">
    <Label className="text-zinc-300">{label}</Label>
    <Select value={value || 'ta'} onValueChange={onChange}>
      <SelectTrigger className="form-input" data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-zinc-900 border-zinc-500/60">
        <SelectItem value="ta">Tá Telecom</SelectItem>
        <SelectItem value="tip">Tip Brasil</SelectItem>
      </SelectContent>
    </Select>
  </div>
);
